import Link from "next/link";
import Countdown from "react-countdown";
import { useEffect, useState } from "react";

function Discord({ className = "", fill = "#00AF07", ...props }: { className?: string; fill?: string }) {
	return (
		<svg className={className} width="26" height="30" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_1010_1660)">
				<path
					d="M11.6428 13.545L8.71906 10.9069C8.74948 11.0154 8.77309 11.1028 8.79811 11.1898C8.87095 11.4419 8.94179 11.6943 9.01824 11.945C9.04305 12.0266 9.02144 12.0579 8.93819 12.0521C8.91818 12.0505 8.89817 12.0521 8.87816 12.0521C6.54343 12.0521 4.2087 12.0521 1.87397 12.0521C1.56798 12.0521 1.27681 11.9951 1.02046 11.8172C0.626422 11.5434 0.436909 11.1592 0.436308 10.6881C0.43324 8.18255 0.432773 5.6771 0.434907 3.17178C0.434907 2.81661 0.433506 2.46163 0.434907 2.10646C0.434906 1.79144 0.547091 1.48661 0.751552 1.24607C0.956013 1.00552 1.23953 0.844822 1.55178 0.792484C1.6309 0.781286 1.71083 0.776758 1.79072 0.778946C4.63562 0.778946 7.48052 0.782331 10.3254 0.775761C11.0773 0.773969 11.6832 1.36168 11.683 2.13493C11.6822 5.88813 11.6822 9.64133 11.683 13.3945C11.683 13.4367 11.6794 13.4789 11.6776 13.5211L11.6428 13.545ZM5.11491 3.82956C5.04386 3.73958 4.96462 3.76605 4.89818 3.77382C4.34024 3.83912 3.83494 4.04418 3.37727 4.36372C3.31897 4.40674 3.27167 4.4628 3.23918 4.52737C2.90037 5.18774 2.65953 5.89347 2.52416 6.62256C2.44411 7.0514 2.41049 7.48919 2.36226 7.9238C2.35045 8.03031 2.34465 8.13961 2.4223 8.23676C2.58622 8.44268 2.7868 8.61686 3.01405 8.75061C3.36186 8.95328 3.74128 9.06079 4.14152 9.10061C4.24859 9.11116 4.33744 9.09762 4.39828 8.99549C4.4303 8.94193 4.47832 8.89853 4.51835 8.84916C4.58319 8.76753 4.64643 8.68491 4.70666 8.60767C4.49674 8.50255 4.29522 8.41495 4.1079 8.30386C3.92059 8.19277 3.75129 8.04863 3.62241 7.84835C5.28901 8.77271 6.9402 8.80277 8.59799 7.86825C8.31522 8.24333 7.93019 8.46034 7.47432 8.6011C7.55597 8.70502 7.63321 8.78764 7.69225 8.88161C7.81112 9.07074 7.96281 9.1229 8.18854 9.08607C8.7851 8.98892 9.30521 8.76056 9.71206 8.30525C9.7859 8.22263 9.85214 8.14061 9.83973 8.01598C9.80991 7.72272 9.79851 7.42728 9.75968 7.13521C9.63807 6.21935 9.36389 5.33006 8.9484 4.50387C8.92449 4.45319 8.88712 4.40996 8.84033 4.37885C8.62561 4.25223 8.41268 4.12003 8.18694 4.01511C7.87773 3.87147 7.54371 3.78814 7.20295 3.76964C7.14032 3.76625 7.08288 3.77262 7.06447 3.85764C7.616 4.0408 8.14512 4.26696 8.59619 4.64124C6.89117 3.80388 5.19015 3.83534 3.48453 4.64065C3.96202 4.24785 4.52115 4.01452 5.11491 3.83036V3.82956Z"
					fill={fill}
				/>
				<path
					d="M5.55537 6.84848C5.55537 7.26994 5.25099 7.57037 4.84414 7.55344C4.57418 7.5421 4.33644 7.32708 4.24919 7.01591C4.14913 6.65616 4.39287 6.22951 4.74568 6.14908C5.17354 6.05113 5.55657 6.38201 5.55537 6.84848Z"
					fill={fill}
				/>
				<path
					d="M7.89865 6.83889C7.89865 7.26554 7.58887 7.57074 7.18582 7.55322C6.93387 7.54227 6.71094 7.35712 6.60768 7.07262C6.49941 6.77399 6.63489 6.38876 6.90466 6.22491C7.19023 6.0517 7.54384 6.11919 7.74116 6.38816C7.84122 6.52473 7.91006 6.67405 7.89865 6.83889Z"
					fill={fill}
				/>
			</g>
			<defs>
				<clipPath id="clip0_1010_1660">
					<rect width="11.2491" height="12.7693" fill="white" transform="translate(0.433594 0.775757)" />
				</clipPath>
			</defs>
		</svg>
	);
}

function OpenSea({ className = "", fill = "#00AF07", ...props }: { className?: string; fill?: string }) {
	return (
		<svg className={className} width="30" height="30" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M5.94253 0.775757H6.81683C6.94491 0.795507 7.07298 0.816825 7.20137 0.834695C10.1916 1.24914 12.362 4.10857 11.9587 7.10532C11.5478 10.1525 8.90206 12.3078 5.84859 11.9947C3.50001 11.7536 1.90298 10.4491 1.07315 8.23799C0.907495 7.79533 0.859897 7.30847 0.757812 6.84198V5.96669C0.768146 5.91088 0.782238 5.85571 0.789127 5.79959C0.917019 4.61639 1.41634 3.50424 2.21531 2.62302C3.01429 1.74179 4.07177 1.13687 5.23577 0.8952C5.46875 0.847235 5.7058 0.815885 5.94253 0.775757ZM5.36322 3.4844C5.408 3.58127 5.43211 3.63111 5.45403 3.68221C5.58743 3.99289 5.73586 4.29824 5.84953 4.61582C6.00422 5.04406 6.10913 5.48578 6.04211 5.94788C5.98512 6.33944 5.7797 6.66893 5.58555 7.00124C5.52292 7.10657 5.47 7.2163 5.41238 7.32414C5.53764 7.33825 5.6629 7.35988 5.78815 7.3649C6.31142 7.38465 6.23344 7.25078 6.24127 7.84831C6.24284 7.96525 6.19242 8.00162 6.08094 7.99848C5.86769 7.99252 5.65413 8.00036 5.44088 7.99566C5.11803 7.98813 4.88473 7.78342 4.85655 7.46051C4.84434 7.32132 4.78328 7.30032 4.66867 7.30126C4.27316 7.30439 3.87766 7.30126 3.48216 7.30126C3.08666 7.30126 3.07508 7.31724 3.14804 7.70693C3.31776 8.62673 4.07745 9.26533 5.02283 9.27098C5.95443 9.27631 6.88604 9.2669 7.81733 9.27505C8.17368 9.27819 8.46178 9.14965 8.67377 8.87471C8.86274 8.62736 9.03815 8.36991 9.19923 8.1035C9.3558 7.84581 9.55308 7.63325 9.83115 7.52196C10.0165 7.44703 10.0623 7.32916 10.0463 7.14796C10.0309 6.97208 10.0253 6.95986 9.85057 7.01033C9.41217 7.13573 8.97377 7.27179 8.53067 7.38935C8.34748 7.43826 8.19279 7.51475 8.07348 7.66272C7.8643 7.92136 7.59813 8.02199 7.26275 8.00318C6.87007 7.98155 6.86913 7.99817 6.87101 7.59877C6.87101 7.36835 6.87288 7.35706 7.1043 7.37085C7.29563 7.38245 7.45063 7.3395 7.57245 7.18714C7.73497 6.98431 7.91033 6.79119 8.06158 6.58021C8.39226 6.11842 8.38098 5.6419 8.09728 5.15911C7.86743 4.76786 7.58059 4.41737 7.21859 4.15403C6.93677 3.95026 6.82779 3.72673 6.86474 3.38972C6.88792 3.17748 6.73948 3.03327 6.55943 3.03107C6.37154 3.02857 6.24628 3.1687 6.24065 3.39536C6.23814 3.49129 6.24065 3.58754 6.24065 3.712L5.36322 3.4844ZM3.51097 6.6288C3.58331 6.64886 3.60805 6.66172 3.63247 6.66172C4.09499 6.66172 4.55719 6.66485 5.0197 6.66172C5.04225 6.66143 5.06448 6.65626 5.08485 6.64658C5.10523 6.63689 5.12328 6.62292 5.13775 6.6056C5.32345 6.29774 5.50758 5.98957 5.48221 5.60616C5.4509 5.14689 5.30059 4.72303 5.11709 4.30765C5.10769 4.28633 5.08577 4.27128 5.04381 4.22927L3.51097 6.6288Z"
				fill={fill}
			/>
		</svg>
	);
}

function Twitter({ className = "", fill = "#00AF07", ...props }: { className?: string; fill?: string }) {
	return (
		<svg className={className} width="30" height="30" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.87314 0.775757C1.79447 0.775757 0.109375 2.46085 0.109375 4.53952L0.109375 8.30328C0.109375 10.382 1.79447 12.067 3.87314 12.067H7.6369C9.71557 12.067 11.4007 10.382 11.4007 8.30328V4.53952C11.4007 2.46085 9.71557 0.775757 7.6369 0.775757L3.87314 0.775757ZM8.42968 5.09489C8.42968 7.10365 6.95023 9.42074 4.24612 9.42074C3.44674 9.42117 2.66408 9.18412 1.99126 8.73779C2.10785 8.75245 2.22519 8.75989 2.34264 8.76008C3.00493 8.76117 3.6483 8.53171 4.16913 8.10868C3.86235 8.10231 3.56514 7.99706 3.31899 7.80762C3.07285 7.61819 2.89004 7.35401 2.79608 7.05197C3.01622 7.09602 3.24322 7.08711 3.4595 7.02592C3.12653 6.95661 2.82704 6.77021 2.61195 6.4984C2.39685 6.22659 2.27943 5.88615 2.27964 5.53494V5.51613C2.48402 5.63309 2.71239 5.69809 2.94587 5.70575C2.63487 5.49066 2.41475 5.16118 2.33024 4.7843C2.24572 4.40741 2.30317 4.01139 2.49089 3.67673C2.86024 4.14609 3.32086 4.52996 3.84289 4.80345C4.36492 5.07693 4.93671 5.23392 5.52118 5.26425C5.44828 4.93825 5.48127 4.59649 5.61505 4.29181C5.74883 3.98714 5.97596 3.73652 6.2613 3.5787C6.54665 3.42089 6.87433 3.36466 7.19368 3.41873C7.51303 3.47279 7.80626 3.63412 8.02804 3.87779C8.35719 3.81047 8.67286 3.68569 8.96151 3.50881C8.85145 3.86076 8.62171 4.15952 8.31488 4.34969C8.60629 4.31469 8.89087 4.23416 9.1589 4.11085C8.96164 4.41625 8.71327 4.68281 8.42548 4.89802C8.42828 4.96316 8.42968 5.02975 8.42968 5.09489Z"
				fill={fill}
			/>
		</svg>
	);
}

function CountdownRenderer({ days, hours, minutes, seconds }) {
	return (
		<span>
			{days} days {hours} hours {minutes} mins {seconds} secs
		</span>
	);
}

function useAnnouncementControls({ countdownDate }) {
	const now = new Date();
	const [hidden, setHidden] = useState(now > countdownDate);
	const [complete, setComplete] = useState(now > countdownDate);

	return { hidden, setHidden, complete, setComplete };
}

function Announcement({ countdownDate, hidden, setHidden, complete, setComplete }) {
	return (
		!hidden && (
			<div className="bg-primary text-white">
				{complete ? (
					<span className="flex flex-row text-center sm:text-left items-center sm:pl-4 text-sm sm:text-base p-1">
						<span className="flex-grow flex sm:inline-flex sm:flex-row flex-col justify-center">
							Public Mint is now live!{" "}
							<Link href="/buy">
								<a className="ml-2">Click here</a>
							</Link>
						</span>
						<button
							className="p-2 sm:mr-2"
							onClick={() => {
								setHidden(true);
							}}
						>
							X
						</button>
					</span>
				) : (
					<span className="flex flex-row text-center sm:text-left items-center sm:pl-4 text-sm sm:text-base p-1">
						<span className="flex-grow flex sm:inline-flex sm:flex-row flex-col justify-center">
							<span className="sm:mr-10 block sm:inline-flex">Public Mint goes live on Feb 10, 2022!</span>
							<Countdown
								onComplete={() => {
									setComplete(true);
								}}
								date={countdownDate}
								renderer={CountdownRenderer}
							/>
						</span>
						<button
							className="p-2 sm:mr-2"
							onClick={() => {
								setHidden(true);
							}}
						>
							X
						</button>
					</span>
				)}
			</div>
		)
	);
}

function useRenderState() {
	const [shouldRender, setShouldRender] = useState(false);

	useEffect(() => {
		if (!shouldRender) {
			setShouldRender(true);
		}
	}, [shouldRender]);

	return { shouldRender };
}

function DelayRender({ children }) {
	const { shouldRender } = useRenderState();

	return shouldRender ? <>{children}</> : null;
}

export default function Header() {
	const countdownDate = new Date(1044519600*1000);
	const { hidden, setHidden, complete, setComplete } = useAnnouncementControls({ countdownDate });

	return (
		<>
			<div className="absolute left-0 right-0 z-20 top-0">
				<DelayRender>
					<Announcement countdownDate={countdownDate} hidden={hidden} setHidden={setHidden} complete={complete} setComplete={setComplete} />
				</DelayRender>
			</div>
			<div className={`h-12 flex absolute right-0 sm:right-2 p-2 ${hidden ? "top-2" : "top-12"}`}>
				<a className="mr-4" href="https://opensea.io/collection/seeds-luciensmith" rel="noreferrer" target="_blank">
					<OpenSea />
				</a>
				<a className="mr-4" href="https://discord.com/invite/zE7xtUYqTc" rel="noreferrer" target="_blank">
					<Discord />
				</a>
				<a href="https://twitter.com/feareatsthesoil" rel="noreferrer" target="_blank">
					<Twitter />
				</a>
			</div>
		</>
	);
}
